export const enAgentGuiCollaboration = {
  collaborationModeConsult: "Consult",
  collaborationModeFork: "Fork",
  collaborationModeDelegate: "Delegate",
  collaborationModeHandoff: "Handoff",
  collaborationTriggerUser: "Manual",
  collaborationTriggerAgent: "Agent",
  collaborationTriggerPolicy: "Policy",
  collaborationStatusRunning: "Running",
  collaborationStatusCompleted: "Completed",
  collaborationStatusFailed: "Failed",
  collaborationStatusCanceled: "Canceled",
  collaborationPlanLabel: "Plan: {{name}}",
  collaborationUsageTokens: "Tokens: {{input}} in · {{output}} out",
  collaborationFailureReason: "Failure: {{reason}}",
  collaborationResultShow: "Show result",
  collaborationResultHide: "Hide result",
  collaborationAdopt: "Adopt",
  collaborationReject: "Reject",
  collaborationAdopted: "Adopted",
  collaborationRejected: "Not adopted",
  collaborationAdoptionFailed: "Failed to record the adoption decision.",
  composerModelPlanBadge: "Plan: {{name}}",
  composerModelSearchPlaceholder: "Search models",
  composerModelSearchEmpty: "No matching models",
  composerModelFavoritesGroup: "Favorites",
  composerModelRecentsGroup: "Recently used",
  composerModelSwitchNextTurnHint: "Applies from the next request",
  composerModelFavoriteAdd: "Add to favorites",
  composerModelFavoriteRemove: "Remove from favorites",
  consultEntryLabel: "Consult model",
  consultDialogTitle: "Consult a model",
  consultPlanLabel: "Plan",
  consultModelLabel: "Model",
  consultQuestionLabel: "Question",
  consultQuestionPlaceholder: "Ask another model for advice...",
  consultIncludeContextLabel: "Attach the latest assistant reply as context",
  consultSubmit: "Consult",
  consultSubmitting: "Consulting...",
  mentionFilterCollab: "Collaboration",
  mentionGroupCollabSessions: "Collaboration sessions",
  mentionEmptyCollabSessions: "No collaboration sessions yet",
  mentionCollaboratorFallback: "Collaborator"
} as const;
